import { Center, Spinner, Text } from '@chakra-ui/react';
import AppCard from 'presentation/components/shared/card/AppCard';
import ErrorContainer from 'presentation/components/shared/ErrorContainer';
import OrderBookSection from 'presentation/components/shared/orderBook/OrderBookSection';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useFetchPeOrderBookQuery } from 'rtkQuery/sharespro/queries/peService';

interface Props {
  companyId: ID;
}

const PeOrderBook: FC<Props> = ({ companyId }) => {
  const { data, error, isFetching, refetch } = useFetchPeOrderBookQuery(companyId);

  const { t } = useTranslation();

  let content;
  if (data) {
    if (data.buy.length === 0 && data.sell.length === 0) {
      content = <Text>{t('noData')}</Text>;
    } else {
      content = <OrderBookSection data={data} />;
    }
  } else if (isFetching) {
    content = <Spinner />;
  } else if (error) {
    content = (
      <ErrorContainer
        error={error}
        onRetry={() => {
          refetch();
        }}
      />
    );
  } else {
    content = <Spinner />;
  }

  return (
    <AppCard p="20px" maxW="720px">
      <Center>{content}</Center>
    </AppCard>
  );
};

export default PeOrderBook;
